module.exports = __webpack_public_path__ + "img/logo-name.57bc1295.png";